export default function Services() {
  const services = [
    {
      icon: 'ri-home-4-line',
      title: '物件仲介サービス',
      description: 'バケーションレンタルに適した物件の選定から契約まで、専門スタッフが丁寧にサポートいたします。市場分析に基づいた最適な物件をご提案します。'
    },
    {
      icon: 'ri-line-chart-line',
      title: '収益最適化コンサルティング',
      description: '稼働率向上と収益最大化を実現するための戦略立案をサポート。価格設定、マーケティング施策など、データに基づいた提案を行います。'
    },
    {
      icon: 'ri-shield-check-line',
      title: '運用管理サポート',
      description: '物件の維持管理、ゲスト対応、清掃手配など、運用に関わる業務を包括的にサポート。オーナー様の負担を最小限に抑えます。'
    },
    {
      icon: 'ri-file-text-line',
      title: '法務・税務サポート',
      description: 'バケーションレンタル事業に関する法規制への対応、契約書作成、税務相談など、専門家と連携してサポートいたします。'
    },
    {
      icon: 'ri-global-line',
      title: 'インバウンド対応',
      description: '海外からのゲストに対応するための多言語サポート、決済システムの整備など、グローバルな視点でのサービスを提供します。'
    },
    {
      icon: 'ri-customer-service-2-line',
      title: '24時間サポート体制',
      description: '緊急時の対応やゲストからの問い合わせに、24時間365日対応可能な体制を整備。安心して運用いただけます。'
    }
  ];

  return (
    <section id="services" className="bg-white py-36">
      <div className="max-w-[1400px] mx-auto px-8">
        <h2 className="font-serif text-[42px] text-black mb-20 ml-[10%]">サービス内容</h2>
        
        <div className="grid grid-cols-3 gap-8 max-w-[1200px] mx-auto">
          {services.map((service, index) => (
            <div
              key={index}
              className="bg-white border border-[#E5E5E5] rounded-lg p-10 hover:shadow-[0_2px_8px_rgba(0,0,0,0.06)] transition-shadow duration-200"
            >
              <div className="w-12 h-12 flex items-center justify-center mb-6">
                <i className={`${service.icon} text-[48px] text-black`} />
              </div>
              <h3 className="text-[22px] font-bold text-black mb-6">{service.title}</h3>
              <p className="text-[15px] text-[#666666] leading-[1.8]">{service.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
